import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SidebarNavBtnComponent } from '../sidebar-nav-btn/sidebar-nav-btn';

interface NavItem {
  labelKey: string;
  icon: string;
  path?: string;
}

@Component({
  selector: 'app-sidebar-nav-section',
  imports: [TranslatePipe, SidebarNavBtnComponent],
  templateUrl: './sidebar-nav-section.html',
  styleUrl: './sidebar-nav-section.scss',
})
export class SidebarNavSectionComponent {
  sectionIcon = input.required<string>();
  sectionLabelKey = input.required<string>();
  items = input.required<NavItem[]>();
  isOpen = input.required<boolean>();
  expanded = input.required<boolean>();
  activePath = input<string>();

  toggleSection = output<void>();
  navClicked = output<string | undefined>();

  isItemActive(path?: string): boolean {
    const activePath = this.activePath();

    if (!path || !activePath) {
      return false;
    }

    return (
      activePath === path ||
      activePath.startsWith(`${path}/`) ||
      activePath.startsWith(`${path}?`)
    );
  }
}
